var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "containerRef",
    class: ['text-ellipsis-container', 'max-h-[150px]', 'overflow-hidden', _vm.$attrs.class],
    style: {
      textAlign: _vm.textAlign
    },
    on: {
      "mouseenter": _vm.updateOverflow
    }
  }, [_c('Tooltip', {
    ref: "tooltipRef",
    staticClass: "text-ellipsis-tooltip",
    attrs: {
      "content": _vm.text,
      "disabled": !_vm.overflowing,
      "max-width": 300,
      "transfer": "",
      "transfer-class-name": "text-ellipsis-tooltip-popper"
    }
  }, [_c('div', {
    staticClass: "text-ellipsis-content",
    style: _vm.contentStyle
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };